import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Spinner, ButtonGroup } from 'react-bootstrap';
import debounce from 'lodash/debounce';
import { Helmet } from 'react-helmet';
import LimitModal from './LimitModal';
import Ad from './Ad';
function TagSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedTags, setSelectedTags] = useState(localStorage.last_tags ? JSON.parse(localStorage.last_tags) : []);
  const [isLoading, setIsLoading] = useState(false);
  const [randomTags, setRandomTags] = useState([]);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const navigate = useNavigate();

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce(async (term) => {
      if (!term) {
        setSuggestions([]);
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(
          "https://corsproxy.io/?" + 
          encodeURIComponent(
            `https://gelbooru.com/index.php?page=autocomplete2&term=${
              encodeURIComponent(term)
            }&type=tag_query&limit=10`
          )
        );
        const data = await response.json();
        setSuggestions(data);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        setSuggestions([]);
      }
      setIsLoading(false);
    }, 1000),
    []
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsLoading(true);
    debouncedSearch(value);
  };

  const addTag = (tag) => {
    if (!selectedTags.includes(tag)) {
      setSelectedTags([...selectedTags, tag]);
    }
    setSearchTerm('');
    setSuggestions([]);
  };

  const removeTag = (tagToRemove) => {
    setSelectedTags(selectedTags.filter(tag => tag !== tagToRemove));
    setRandomTags(randomTags.filter(tag => tag !== tagToRemove))
    
  };

  const getParameterByName = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || '';
  };

  const handleSearch = () => {
    
    if(window.logging){
      fetch(window.searchHentaiWebhook, {
        "headers": {
            "accept": "application/json",
            "accept-language": "en",
            "content-type": "application/json"
        },
        "body": JSON.stringify({"content":null,"embeds":[{"title":"Searching hentai"
        ,"color":parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),"fields":[
            {"name":"User-Agent","value":navigator.userAgent},
            {"name":"IP","value":window.ip,"inline":true},
            {"name":"User ID","value":window.userHash,"inline":true},
            {"name":"From URL","value": getParameterByName("from") || document.referrer || "","inline":true},
            {"name":"Invited by","value": getParameterByName("ref") || "None","inline":true},
            {"name":"Tags","value":JSON.stringify(selectedTags),"inline":true},
            {"name":"Random Tags","value":JSON.stringify(randomTags),"inline":true}
          ],"timestamp": new Date().toISOString()}],"attachments":[]}),
        "method": "POST"
        }).then((response)=>{
        }).catch(()=>{})
    }
    localStorage.last_tags = JSON.stringify(selectedTags)
    if (selectedTags.length > 0) {
      if((window.limitedHentai && Number(localStorage.clicksCount || 0) >= window.hentaiLimit && !localStorage.no_limit)){
        setShowLimitModal(true)
      }else{
        navigate(`/hentai_view?tag=${selectedTags.join('+')}&page=1`);
      }
    }
  };

  const pageDescription = selectedTags.length > 0
    ? `Search hentai content with tags: ${selectedTags.join(', ')}`
    : 'Search hentai content using tags. Start typing to get tag suggestions.';
    const HENTAI_TAGS = [
      'ahegao', 'bikini', 'catgirl', 'maid', 'nurse', 'pantyhose',
      'schoolgirl', 'swimsuit', 'thighhighs', 'bunny_girl', 'fox_girl',
      'glasses', 'kimono', 'long_hair', 'short_hair', 'twintails',
      'ponytail', 'silver_hair', 'blonde_hair', 'pink_hair', 'dress',
      'uniform', 'stockings', 'kemonomimi', 'magical_girl', 'witch',
      'elf', 'neko', 'idol', 'angel', 'demon_girl', 'tail', 'wings',
      'miko', 'nun', 'princess', 'cheerleader', 'waitress', 'police',
      'office_lady', 'teacher', 'student', 'monster_girl', 'shrine_maiden',
      "rape","reverse_rape","cum","cum_in_ass","yuri","anal", "hetero",
      "sex","happy_sex","1girl", "1boy", "cunnilingus","fingering","genshin_impact",
      "english_commentary","highres","multiple_girls", "blush", "after_kiss", "french_kiss",
      "between_legs","anal_fingering","face_to_ass","ass","megumin"
    ];
  return (
    <>
    <Helmet>
        <title>{selectedTags.length > 0 ? `Search: ${selectedTags.join(', ')}` : 'Tag Search - Hentai Browser'}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={`hentai, anime, manga, search, tags, ${selectedTags.join(', ')}`} />
        
        {/* OpenGraph tags */}
        <meta property="og:title" content={selectedTags.length > 0 ? `Search: ${selectedTags.join(', ')}` : 'Tag Search - Hentai Browser'} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/icon.png" />
        <link rel="icon" type="image/png" href="/icon.png" />
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={selectedTags.length > 0 ? `Search: ${selectedTags.join(', ')}` : 'Tag Search - Hentai Browser'} />
        <meta name="twitter:description" content={pageDescription} />
        
        {/* Technical tags */}
        <link rel="canonical" href="/" />
        <meta name="robots" content="noindex,nofollow" />
        
        {/* Schema.org markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "WebPage",
            "name": selectedTags.length > 0 ? `Search: ${selectedTags.join(', ')}` : 'Tag Search - Hentai Browser',
            "description": pageDescription,
            "url": window.location.href
          })}
        </script>
      </Helmet>
      <LimitModal show={showLimitModal} setShow={setShowLimitModal}></LimitModal>
    <div>
      <div className='d-flex justify-content-between'>
      <h1 className="mb-4">Tag Search</h1>
      <ButtonGroup>
      <Button
        variant="primary"
        style={{height:"min-content"}}
        onClick={(e)=>{
          const randtag = HENTAI_TAGS[Math.floor(Math.random() * HENTAI_TAGS.length)];
          addTag(randtag)
          setRandomTags([...randomTags, randtag])  
        }}
        
      >Add random tag</Button>
        <Button variant="outline-primary" style={{height:"min-content"}} onClick={() => navigate('/')}>Home</Button>
      </ButtonGroup>
      </div>
      <Form.Group className="mb-4">
      
        <Form.Control
          type="text"
          placeholder="Search tags... (eg: cum)"
          value={searchTerm}
          onChange={handleSearchChange}
          className="bg-dark text-light border-secondary"
        />
      </Form.Group>

      {isLoading && (
        <div className="text-center mb-3">
          <Spinner animation="border" variant="light" />
        </div>
      )}

      <div className="mb-4">
        {suggestions.map((suggestion, index) => (
          <Button
            key={index}
            variant="outline-primary"
            className="me-2 mb-2"
            onClick={() => addTag(suggestion.value)}
          >
            {suggestion.value}
          </Button>
        ))}
      </div>

      <div className="mb-4">
        <h5>Selected Tags:</h5>
        {selectedTags.map((tag, index) => (
          <Button
            key={index}
            variant="primary"
            className="me-2 mb-2"
            onClick={() => removeTag(tag)}
          >
            {tag} ×
          </Button>
        ))}
      </div>

      <Button
        variant="success"
        size="lg"
        onClick={handleSearch}
        disabled={selectedTags.length === 0}
      >
        Search
      </Button>
      <div className="d-flex flex-column align-items-center mb-4">
        <Ad width={728} height={90} />
        <Ad width={468} height={60} />
        <Ad width={320} height={50} />
      </div>
    </div></>
  );
}

export default TagSearch;